import ReactJson from 'react-json-view';
import { useMemo } from 'react';
import { parseSchema } from './utils';

interface JSONSchemaProps {
    value: string;
}

const JSONSchema = ({ value }: JSONSchemaProps) => {
    const json = useMemo(() => parseSchema(value), [value]);

    const error = useMemo(
        () => (
            <div className="text-xs text-red-6 text-center py-6">
                Schema is not a valid JSON
            </div>
        ),
        []
    );

    if (!json) {
        return error;
    }

    try {
        return (
            <ReactJson
                displayDataTypes={false}
                displayObjectSize={false}
                name={false}
                src={json}
                style={{
                    fontSize: '12px'
                }}
            />
        );
    } catch {
        return error;
    }
};

export default JSONSchema;
